import EcoSpace from 'eco-design/base/eco-space';
import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';

const SectionU2 = () => {
    const { t } = useLang('theProduct.SectionU2');
    const { isH5 } = useDeviceDetect();
    return (
        <div className={styles.SectionU2}>
            <EcoSpace />
            <div className="eco-content">
                {!isH5 ? (
                    <div className="view">
                        <div className="area areaa">
                            <div className="info">
                                <div>
                                    <div className="l1">{t('p5_1')}</div>
                                    <div className="l2">{t('p5_2')}</div>
                                </div>
                                <div>
                                    <div className="l3">{t('p5_3')}</div>
                                    <div className="l4">{t('p5_4')}</div>
                                </div>
                            </div>
                            <div className="item-img">
                                <EfImg
                                    pc="https://websiteoss.ecoflow.com/upload/image/1745550953969/p5.jpg"
                                    pad="https://websiteoss.ecoflow.com/upload/image/1745550953969/p5.jpg"
                                    h5="https://websiteoss.ecoflow.com/upload/image/1745550958358/p5_h5.jpg"
                                />
                            </div>
                        </div>
                        <div className="area areab">
                            <div className="info">
                                <div className="l1">{t('p1_1')}</div>
                                <div className="l2">{t('p1_2')}</div>
                                <div className="l3">{t('p1_3')}</div>
                            </div>
                            <div className="item-img">
                                <EfImg
                                    pc="https://websiteoss.ecoflow.com/upload/image/1745549174560/p1.jpg"
                                    pad="https://websiteoss.ecoflow.com/upload/image/1745549174560/p1.jpg"
                                    h5="https://websiteoss.ecoflow.com/upload/image/1751013334105/p1_h5.jpg"
                                />
                            </div>
                        </div>
                        <div className="area areac">
                            <div className="info">
                                <div className="l1">{t('p2_1')}</div>
                                <div className="l2">{t('p2_2')}</div>
                            </div>
                            <div className="item-img">
                                <EfImg
                                    pc="https://websiteoss.ecoflow.com/upload/image/1751006545687/p2.jpg"
                                    pad="https://websiteoss.ecoflow.com/upload/image/1751006545687/p2.jpg"
                                    h5="https://websiteoss.ecoflow.com/upload/image/1751006548379/p2_h5.jpg"
                                />
                            </div>
                        </div>
                        <div className="area aread">
                            <div className="info">
                                <div className="l1">{t('p3_1')}</div>
                                <div className="l2">{t('p3_2')}</div>
                            </div>
                            <div className="item-img">
                                <EfImg
                                    pc="https://websiteoss.ecoflow.com/upload/image/1751007219838/p4.jpg"
                                    pad="https://websiteoss.ecoflow.com/upload/image/1751007219838/p4.jpg"
                                    h5="https://websiteoss.ecoflow.com/upload/image/1751007222272/p4_h5.jpg"
                                />
                            </div>
                        </div>
                        <div className="area areae">
                            <div className="info">
                                <div className="l1">{t('p6_1')}</div>
                                <div className="l2">{t('p6_2')}</div>
                            </div>
                            <div className="item-img">
                                <EfImg
                                    pc="https://websiteoss.ecoflow.com/upload/image/1751008314665/p5.jpg"
                                    pad="https://websiteoss.ecoflow.com/upload/image/1751008314665/p5.jpg"
                                    h5="https://websiteoss.ecoflow.com/upload/image/1751008243544/p5_h5.jpg"
                                />
                            </div>
                        </div>
                        <div className="area areaf">
                            <div className="info">
                                <div className="l1">{t('p4_1')}</div>
                                <div className="l2">{t('p4_2')}</div>
                                <div className="l3">{t('p4_3')}</div>
                            </div>
                            <div className="item-img">
                                <EfImg
                                    pc="https://websiteoss.ecoflow.com/upload/image/1751008557878/p6.jpg"
                                    pad="https://websiteoss.ecoflow.com/upload/image/1751008557878/p6.jpg"
                                    h5="https://websiteoss.ecoflow.com/upload/image/1751008560790/p6_h5.jpg"
                                />
                            </div>
                        </div>
                        <div className="area areag">
                            <div className="info">
                                <div className="l1">{t('p7_1')}</div>
                                <div className="l2">{t('p7_2')}</div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="view">
                        <div className="area areab">
                            <div className="info">
                                <div className="l1">{t('p1_1')}</div>
                                <div className="l2">{t('p1_2')}</div>
                                <div className="l3">{t('p1_3')}</div>
                            </div>
                            <div className="item-img">
                                <EfImg
                                    pc="https://websiteoss.ecoflow.com/upload/image/1745549174560/p1.jpg"
                                    pad="https://websiteoss.ecoflow.com/upload/image/1745549174560/p1.jpg"
                                    h5="https://websiteoss.ecoflow.com/upload/image/1751013334105/p1_h5.jpg"
                                />
                            </div>
                        </div>
                        <div className="row2-container">
                            <div className="area areac">
                                <div className="info">
                                    <div className="l1">{t('p2_1')}</div>
                                    <div className="l2">{t('p2_2')}</div>
                                </div>
                                <div className="item-img">
                                    <EfImg
                                        pc="https://websiteoss.ecoflow.com/upload/image/1751006545687/p2.jpg"
                                        pad="https://websiteoss.ecoflow.com/upload/image/1751006545687/p2.jpg"
                                        h5="https://websiteoss.ecoflow.com/upload/image/1751006548379/p2_h5.jpg"
                                    />
                                </div>
                            </div>
                            <div className="area areag">
                                <div className="info">
                                    <div className="l1">{t('p7_1')}</div>
                                    <div className="l2">{t('p7_2')}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row3-container">
                            <div className="row3-wrapper">
                                <div className="area aread">
                                    <div className="info">
                                        <div className="l1">{t('p3_1')}</div>
                                        <div className="l2">{t('p3_2')}</div>
                                    </div>
                                    <div className="item-img">
                                        <EfImg
                                            pc="https://websiteoss.ecoflow.com/upload/image/1751007219838/p4.jpg"
                                            pad="https://websiteoss.ecoflow.com/upload/image/1751007219838/p4.jpg"
                                            h5="https://websiteoss.ecoflow.com/upload/image/1751007222272/p4_h5.jpg"
                                        />
                                    </div>
                                </div>
                                <div className="area areaf">
                                    <div className="info">
                                        <div className="l1">{t('p4_1')}</div>
                                        <div className="l2">{t('p4_2')}</div>
                                        <div className="l3">{t('p4_3')}</div>
                                    </div>
                                    <div className="item-img">
                                        <EfImg
                                            pc="https://websiteoss.ecoflow.com/upload/image/1751008557878/p6.jpg"
                                            pad="https://websiteoss.ecoflow.com/upload/image/1751008557878/p6.jpg"
                                            h5="https://websiteoss.ecoflow.com/upload/image/1751008560790/p6_h5.jpg"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row4-container">
                            <div className="row4-wrapper">
                                <div className="area areaa">
                                    <div className="info">
                                        <div>
                                            <div className="l1">{t('p5_1')}</div>
                                            <div className="l2">{t('p5_2')}</div>
                                        </div>
                                        <div>
                                            <div className="l3">{t('p5_3')}</div>
                                            <div className="l4">{t('p5_4')}</div>
                                        </div>
                                    </div>
                                    <div className="item-img">
                                        <EfImg
                                            pc="https://websiteoss.ecoflow.com/upload/image/1745550953969/p5.jpg"
                                            pad="https://websiteoss.ecoflow.com/upload/image/1745550953969/p5.jpg"
                                            h5="https://websiteoss.ecoflow.com/upload/image/1745550958358/p5_h5.jpg"
                                        />
                                    </div>
                                </div>
                                <div className="area areae">
                                    <div className="info">
                                        <div className="l1">{t('p6_1')}</div>
                                        <div className="l2">{t('p6_2')}</div>
                                    </div>
                                    <div className="item-img">
                                        <EfImg
                                            pc="https://websiteoss.ecoflow.com/upload/image/1751008314665/p5.jpg"
                                            pad="https://websiteoss.ecoflow.com/upload/image/1751008314665/p5.jpg"
                                            h5="https://websiteoss.ecoflow.com/upload/image/1751008243544/p5_h5.jpg"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
export default SectionU2;
